export default __webpack_public_path__ + "static/media/post_sm13.337ef8c9.jpg";